import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DashboardSessionService {
  private sessionId: string;

  generateUUID() {
    this.sessionId = crypto.randomUUID();
  }

  get sessionUUID() {
    return this.sessionId;
  }

  deleteSessionUUID() {
    this.sessionId = '';
  }
}
